import _Navbar from "@kibt/meta-ui/es/navbar";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import _regeneratorRuntime from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/regenerator";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { defineComponent, inject, onMounted, ref } from '@vue/composition-api';
import yoda from '@ks/yoda-js-sdk';
import { useGetDevicesInfo } from '../attribution/utils';
import { http } from '@/utils/axios';
export default defineComponent({
  components: {
    MNavbar: _Navbar
  },
  setup: function setup() {
    var $k18n = inject('$k18n');
    // 设备参数上报
    var _useGetDevicesInfo = useGetDevicesInfo(),
      getDevicesInfo = _useGetDevicesInfo.getDevicesInfo,
      devicesInfo = _useGetDevicesInfo.devicesInfo;
    var handleClose = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return yoda.ready();
              case 2:
                yoda.webview.backOrClose();
              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function handleClose() {
        return _ref.apply(this, arguments);
      };
    }();
    var showError = ref(true);
    var showLoading = ref(true);
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var url, jump_url, api, params, key, res;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              url = window.location.href;
              _context2.next = 3;
              return getDevicesInfo();
            case 3:
              if (!url.includes('/t/')) {
                _context2.next = 21;
                break;
              }
              showError.value = false;
              api = url.replace('/t/', '/s/');
              params = {};
              for (key in devicesInfo.value) {
                if (_typeof(devicesInfo.value[key]) === 'object') {
                  params[key] = JSON.stringify(devicesInfo.value[key]);
                } else {
                  params[key] = devicesInfo.value[key].toString();
                }
              }
              _context2.prev = 8;
              _context2.next = 11;
              return http.post(api, {
                metaInfo: params
              });
            case 11:
              res = _context2.sent;
              jump_url = res.url || '';
              _context2.next = 18;
              break;
            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](8);
              console.error(_context2.t0);
            case 18:
              _context2.prev = 18;
              if (jump_url) {
                // window.location.href = jump_url
                window.location.replace(jump_url);
              } else {
                showError.value = true;
              }
              return _context2.finish(18);
            case 21:
              showLoading.value = false;
            case 22:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[8, 15, 18, 21]]);
    })));
    return {
      handleClose: handleClose,
      showError: showError,
      devicesInfo: devicesInfo,
      showLoading: showLoading
    };
  }
});